import React from "react";

const BLog = () => {
  return (
    <div id="blog" className="min-h-[400px] max-w-[1100px] mx-auto py-20">
      <div className="title mt-8  mb-8 lg:mt-12 lg:mb-20 ">
        <h2 className="lg:text-6xl text-4xl text-primary font-bold tracking-widest   title-project">
          Blog
        </h2>
      </div>
      <div className="blogs  flex justify-center items-center">
        <h2 className="text-2xl font-bold text-center my-6 rounded text-primary border py-2 px-4">
          Coming Soon
        </h2>
      </div>
    </div>
  );
};

export default BLog;
